import React, { useState, useEffect } from "react";

import { fetchData } from '../utilities/async';
import LayoutHeader from '../Layout/LayoutHeader';
import Loader from '../components/Loader';
import TagFigure from '../components/TagFigure';
import ItemControls from '../components/ItemControls';
import WebItem from '../components/WebItem';

const Web = (props) => {
  // data
  const { REACT_APP_CDN } = process.env;
  const endpoint = '/json/kidkrazydotnet-web.json';
  //pathing
  const imagePath = REACT_APP_CDN + '/_images/thumbs/web/';
  const imagePathFull = REACT_APP_CDN + '/images/web/';
  const imagePathHero = REACT_APP_CDN + '/images/hero/web/';
  // state
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dataUrl, setDataUrl] = useState([]);

  const [details, setDetails] = useState(false);
  const [viewList, setViewList] = useState(true);
  const [selectedProject, setSelectedProject] = useState(0);
  const currentView = dataUrl[selectedProject];

  // Run once on first render
  useEffect(() => {
    window.scrollTo(0, 0);

    fetchData(endpoint).then((ActualData) => {
      setDataUrl(ActualData.data);
      setError(null);
      // console.log('data', ActualData.data);
    })
      .catch((err) => {
        setError(err.message);
        setDataUrl(null);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [endpoint]);

  const detailOpen = (index) => {
    setDetails(true);
    setSelectedProject(index);
  }

  const detailClose = (children) => {
    setDetails(!setDetails);
  }

  const detailPrev = (children) => {

    if (selectedProject === 0) {
      detailClose();
    }

    setSelectedProject(selectedProject - 1);
    window.scrollTo(0, 0);
  }

  const detailNext = (children) => {
    const projectTotal = dataUrl.length;

    if (selectedProject === projectTotal - 1) {
      detailClose();
    }

    setSelectedProject(selectedProject + 1);
    window.scrollTo(0, 0);
  }

  // sort by date (desc) and prioritize featured
  let sorted = dataUrl.sort((a, b) => {
    if (a.featured === b.featured) {
      // featured is only important when date is the same
      return b.date - a.date;
    }
    return a.featured > b.featured ? -1 : 1;
  });
  // console.log('sorted', dataUrl.sort((a, b) => b.date - a.date));

  let ProjectList = sorted.map((item, index) => {
    return (
      <TagFigure
        key={index}
        tabIndex="0"
        className={'web__thumb' + `${item.featured ? ' featured' : ''}`}
        src={item.featured ? imagePathHero + item.hero : imagePath + item.hero}
        onClick={(e) => detailOpen(index, e)}
        caption={item.title}
      />
    )
  })

  if (loading) return <Loader />;

  if (error || !dataUrl) {
    return <p>There was an error loading your data!</p>;
  }

  if (details && dataUrl.length > 0) {
    return (
      <>
        <WebItem
          key={selectedProject}
          className='projects__detail'
          hero={imagePathHero + currentView.hero}
          title={currentView.title}
          summary={currentView.summary}
          summaryFull={currentView.summaryFull}
          role={currentView.role}
          keywords={currentView.keywords}
          date={currentView.date}
          link={currentView.link}
          screenshotsPath={imagePathFull}
          screenshots={currentView.screenshots}
        />
        <ItemControls
          className='projects__controls '
          close={() => detailClose()}
          next={() => detailNext()}
          previous={() => detailPrev()}
        />
      </>
    )
  }

  return (
    <>
      <LayoutHeader data={props.header} />
      <div className={viewList ? 'projects--grid' : 'projects--list'}>
        {[ProjectList]}
      </div>
    </>
  );
};

export default Web;